<deep-reader *ngIf="textToSpeechResult" [textToSpeechResult]="textToSpeechResult" [spaceBetweenWords]="true"></deep-reader>
<div *ngIf="!textToSpeechResult">No result to show</div>
